export default __webpack_public_path__ + "static/media/goopter-logo.417ab5dd.svg";